import * as React from "react";
import { createRoot } from "react-dom/client";
import { Address } from "./address/Address";
import { Blocks } from "./Blocks";
import Routes from "./Routes";
import { getParam } from "./getParam";
import { Block } from "./Block";
import { Navigator, SiteFooter } from "./Navigator";
import { Transaction } from "./transaction/Transaction";
import { Assets } from "./Assets";
import { Asset } from "./Asset";
import { Api } from "./Api";
import "./style.css";

function CurrentView({ route }: { route: string }) {
  switch (route) {
    case Routes.ADDRESS:
      return <Address />;
    case Routes.BLOCK:
      return <Block />;
    case Routes.TRANSACTION:
      return <Transaction />;
    case Routes.ASSETS:
      return <Assets />;
    case Routes.ASSET:
      return <Asset />;
    case Routes.API:
      return <Api />;
    default:
      return <Blocks />;
  }
}

function App() {
  const [route] = React.useState(() => getParam("route") || Routes.HOME);

  React.useEffect(() => {
    document.title = "Telestai Explorer";
  }, []);

  return (
    <>
      <Navigator />
      <CurrentView route={route} />
      <SiteFooter />
    </>
  );
}

const container = document.getElementById("app");
const root = createRoot(container!);
root.render(<App />);
